import React, { useEffect, useState } from "react";

// Cycles through a resident's photos inside whatever panel wraps it. Renders the
// current image (+ little dots when there's more than one). Used on both the
// caregiver board (clickable → delete dialog) and the resident kiosk (read-only).
// The parent supplies the panel container + the image CSS class.
export default function PhotoSlideshow({ photos, imgClassName, intervalMs = 7000, paused = false, onSlideClick }) {
  const [i, setI] = useState(0);

  // Reset to the first slide whenever the set changes size (add/delete/switch resident).
  useEffect(() => { setI(0); }, [photos.length]);

  useEffect(() => {
    if (photos.length < 2 || paused) return;
    const id = setInterval(() => setI((p) => (p + 1) % photos.length), intervalMs);
    return () => clearInterval(id);
  }, [photos.length, paused, intervalMs]);

  if (!photos.length) return null;
  const idx = Math.min(i, photos.length - 1);
  const cur = photos[idx];

  return (
    <>
      <img
        src={cur.url}
        alt=""
        className={imgClassName}
        onClick={onSlideClick ? () => onSlideClick(cur) : undefined}
        style={onSlideClick ? { cursor: "pointer" } : undefined}
        title={onSlideClick ? "Tap to manage this photo" : undefined}
      />
      {photos.length > 1 && (
        <div className="slideshow-dots">
          {photos.map((p, n) => <span key={p.id} className={n === idx ? "on" : ""} />)}
        </div>
      )}
      {(cur.caption || cur.addedByName) && (
        <div className="slideshow-caption">
          {cur.caption}
          {cur.addedByName && (
            <span className="slideshow-from">{cur.caption ? " · " : ""}from {cur.addedByName}</span>
          )}
        </div>
      )}
    </>
  );
}
